document.addEventListener('DOMContentLoaded', function () {
  initScrollReveal();
  initMobileMenu();
  initIngredientTabs();
});

function initScrollReveal() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
}

function initMobileMenu() {
  var burger = document.querySelector('.burger');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (!burger || !mobileMenu) return;
  burger.addEventListener('click', function () {
    var isOpen = mobileMenu.classList.toggle('open');
    burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu.classList.contains('open')) {
      mobileMenu.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      burger.focus();
    }
  });
}

function initIngredientTabs() {
  var tabs = document.querySelectorAll('[data-tab-trigger]');
  if (!tabs.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-tab-trigger');
      var container = tab.closest('[data-tabs]');
      if (!container) return;

      container.querySelectorAll('[data-tab-trigger]').forEach(function (t) {
        t.classList.remove('on');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('on');
      tab.setAttribute('aria-selected', 'true');

      var blurb = container.querySelector('[data-tab-blurb]');
      var lot = container.querySelector('[data-tab-lot]');
      var nameEl = container.querySelector('[data-tab-name]');

      container.querySelectorAll('[data-tab-content]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-tab-content') !== target;
      });

      var activeMeta = tab.getAttribute('data-tab-meta');
      var activeBlurb = tab.getAttribute('data-tab-blurb-text');
      var activeLot = tab.getAttribute('data-tab-lot-text');

      if (blurb && activeBlurb) blurb.textContent = activeBlurb;
      if (nameEl && activeMeta) nameEl.textContent = activeMeta;
      if (lot && activeLot) lot.textContent = activeLot;
    });
  });
}
